import './TableauManager.scss';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useHistory, useLocation } from 'react-router-dom';
import { TextLoader } from '../loader/TextLoader';
import { useTableauQuery } from '../../contexts/TableauQuery';
import { AdditionalInfo } from '../additionalInfo/AdditionalInfo';
import {
  TableauVizualization,
  IFRAME_BREAKPOINT,
} from '../tableauVizualization/TableauVizualization';
import { getTableauToken } from '../../services/jwt.api';

function TableauManager({ setIsHidden, defaultPath, reportTypeId, ...props }) {
  const history = useHistory();
  const location = useLocation();
  const [query] = useTableauQuery();
  const [isLoading, setIsLoading] = useState();
  const [report, setReport] = useState(false);
  const [queryIsVisible] = useState(false);
  const [showVizError, setShowVizError] = useState(false);
  const [vizReference, setVizReference] = useState(null);
  const [refreshQuery, setRefreshQuery] = useState(false);
  const [queryInfo, setQueryInfo] = useState(null);
  const [tableauToken, setTableauToken] = useState(null);

  const hideInPopover = useMediaQuery(`(max-width:${IFRAME_BREAKPOINT}px)`);

  useEffect(() => {
    if (
      query?.chosenReports &&
      Object.keys(query?.chosenReports).length === 0 &&
      query?.territorySelection?.states &&
      Object.keys(query?.territorySelection?.states).length === 0
    ) {
      setIsHidden(true);
      history.push({
        pathname: defaultPath,
      });
    } else {
      setIsHidden(false);
      setReport(true);
      setRefreshQuery(!refreshQuery);
    }

    return () => {
      setReport(false);
    };
  }, [location]);

  useEffect(() => {
    setIsLoading(true);
    getTableauToken()
    .then(response => {
      setTableauToken(response.token);
    })
    .catch(() => {
      setShowVizError(true);
      setIsLoading(false);
    });
  }, []);

  const removeVizErrorFlags = () => {
    setIsLoading(false);
    if (showVizError) {
      setShowVizError(false);
    }
  };

  return (
    <>
      {isLoading && <TextLoader />}
      <div className="tableauManager__containerMain">
        {report && (
          <>
            {hideInPopover && (
              <AdditionalInfo
                query={queryInfo}
                reportTypeId={reportTypeId}
                viz={vizReference}
                hideInPopover={hideInPopover}
              />
            )}
            {tableauToken &&(
              <div id="tableauContainer">
                <TableauVizualization
                  setQueryInfo={setQueryInfo}
                  vizReference={vizReference}
                  setVizReference={setVizReference}
                  refreshQuery={refreshQuery}
                  setRefreshQuery={setRefreshQuery}
                  query={query}
                  removeVizErrorFlags={removeVizErrorFlags}
                  show={queryIsVisible}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  reportTypeId={reportTypeId}
                  tableauToken={tableauToken}
                  {...props}
                />
              </div>
            )}
            {!hideInPopover && !isLoading && queryInfo !== null && (
              <div id="queryContainer">
                <AdditionalInfo
                  query={queryInfo}
                  reportTypeId={reportTypeId}
                  viz={vizReference}
                  hideInPopover={hideInPopover}
                />
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}

TableauManager.propTypes = {
  setIsHidden: PropTypes.func.isRequired,
  defaultPath: PropTypes.string.isRequired,
  reportTypeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default TableauManager;
